<template>
  <div>
    <div class="container">
      <div
        class="col-md-12 col-sm-12 col-lg-12 col-xlg-12"
        style="padding-left: 0;margin: 2% 0;"
      >
        <router-link :to="{ name: 'Home' }"
          ><img class="backimg" src="@/assets/icons/Back.svg"
        /></router-link>
        <router-link :to="{ name: 'Home' }"
          ><div class="routename">Home /</div></router-link
        >
        <div class="routename current">Settings</div>
      </div>
      <div class="row marginleftright">
        <p class="page-title">Settings</p>
        <div class="hr-line"></div>
        <div class="setting-list">
          <div class="row marginleftright" v-if="subscriberid">
            <p
              class="col-lg-3 col-md-4 col-sm-8 setting-menu"
              style="padding-left:0;padding:right:0;"
            >
              Notifications
            </p>
            <div class="col-lg-3 col-md-3 col-sm-4">
              <label class="switch">
                <input
                  type="checkbox"
                  @change="notificationToggle()"
                  v-model="notification"
                />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
          <router-link to="/help" @click="openHelpCenter"
            ><p class="setting-menu">Help Center</p></router-link
          >
          <p class="setting-menu" @click="openAboutPopup">About</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { EventBus } from "@/main";
import GoogleAnalytics from "@/mixins/GoogleAnalytics";

export default {
  name: "settings",
  data() {
    return {
      notification: true,
    };
  },
  computed: {
    ...mapGetters(["subscriberid"]),
  },
  watch: {
    subscriberid() {
      if (this.subscriberid) {
        this.getStatus();
      }
    },
  },
  components: {},
  activated() {
    // console.log("settings-activated");
    if (!this.subscriberid) {
      // this.$router.push({ name: 'Home' });
      // return;
    } else {
      this.getStatus();
    }
  },
  beforeDestroy() {
    // console.log("settings-beforeDestroy");
  },
  deactivated() {
    // console.log("settings-deactivated");
  },
  created() {
    // console.log("settings");
    if (!this.subscriberid) {
      // this.$router.push({ name: 'Home' });
      // return;
    } else {
      this.getStatus();
    }
  },
  methods: {
    ...mapActions([
      "unsubscribeFromTopics",
      "subscribeVendorAndSubscriberTopics",
      "initFCMNotifications",
    ]),
    openHelpCenter() {
      // GA
      let GA = {
        MenuItem: "Help Center",
      };
      this.menuEvent(GA);
    },
    getStatus() {
      let status = JSON.parse(localStorage.getItem("notificationStatus"));
      // console.log("status", status);
      if (!status) {
        this.notification = false;
      } else {
        this.subscribeVendorAndSubscriberTopics();
      }
    },
    openAboutPopup() {
      // GA
      let GA = {
        MenuItem: "About",
      };
      this.menuEvent(GA);
      EventBus.$emit("AboutPopup");
    },
    notificationToggle() {
      // console.log("checked", this.notification);
      if (!this.notification) {
        this.unsubscribeFromTopics(true);
      } else {
        this.subscribeVendorAndSubscriberTopics();
        // this.initFCMNotifications();
      }
    },
    togglePurchseHistoryPopup(state) {
      this.showPurchaseHistory = state;
    },
  },
  mixins: [GoogleAnalytics],
};
</script>

<style lang="scss" scoped>
.page-title {
  color: #212121;
  font-family: "ProximanovaBold";
  font-size: 32px;
  letter-spacing: 1px;
  line-height: 49px;
  margin-top: 2%;
  margin-bottom: 1%;
}
.hr-line {
  margin: 1% 0 2% 0;
  border-bottom: 1px solid rgba(10, 10, 10, 0.44);
}
.setting-list {
  p {
    opacity: 0.9;
    color: #212121;
    font-family: "ProximanovaSemibold";
    font-size: 18px;
    font-style: normal;
    letter-spacing: 0.55px;
    line-height: 27px;
    margin-bottom: 18px;
    text-transform: uppercase;
    cursor: pointer;
  }
}
.marginleftright {
  margin-left: 0;
  margin-right: 0;
}
.switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 18px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // background-color: #cccccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 4px;
  bottom: 2px;
  background-color: #676767;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #ffffff;
  &::before {
    left: 18px;
    background-color: #4558dd;
  }
}

input:focus + .slider {
  box-shadow: 0 0 1px #4558dd;
}

input:checked + .slider:before {
  // -webkit-transform: translateX(32px);
  // -ms-transform: translateX(32px);
  // transform: translateX(32px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
  border: 1px solid #000000;
}

.slider.round:before {
  border-radius: 50%;
}
.routename {
  color: #acacac;
  font-family: "ProximanovaSemibold";
  float: left;
  font-size: 18px;
  margin-right: 10px;
  &.current {
    color: #212121;
  }
  &:hover {
    color: #212121;
  }
}
.backimg {
  float: left;
  margin-top: -5px;
  margin-right: 1%;
}
</style>



// WEBPACK FOOTER //
// src/components/Settings/settings.vue